import { useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const PianoConti = ({ meta, admin, onChanged }) => {
  const [c, setC] = useState({ codice: "", nome: "" });
  const add = async () => { try { await api.post("/coge/conti", c); toast.success("Conto aggiunto"); setC({ codice: "", nome: "" }); onChanged(); } catch (e) { toast.error(errMsg(e)); } };
  const del = async (k) => { if (!window.confirm("Eliminare il conto?")) return; try { await api.delete(`/coge/conti/${k}`); onChanged(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className="space-y-4" data-testid="coge-piano">
      {admin && (
        <div className="flex flex-wrap items-end gap-2 rounded-xl border border-slate-200 bg-white p-4">
          <Input className="w-32 font-mono" placeholder="es. 30.20" data-testid="coge-new-code" value={c.codice} onChange={(e) => setC({ ...c, codice: e.target.value })} />
          <Input className="w-72" placeholder="Nome del conto" data-testid="coge-new-name" value={c.nome} onChange={(e) => setC({ ...c, nome: e.target.value })} />
          <Button className="bg-sky-600 hover:bg-sky-700" data-testid="coge-new-add" onClick={add}>Aggiungi conto</Button>
          <span className="text-xs text-slate-500">Il codice deve iniziare con un mastro esistente.</span>
        </div>
      )}
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {Object.entries(meta.mastri).sort(([a], [b]) => a.localeCompare(b)).map(([m, nome]) => (
          <div key={m} className="rounded-xl border border-slate-200 bg-white shadow-sm">
            <div className="flex justify-between bg-slate-900 px-4 py-2 text-xs font-semibold uppercase tracking-wider text-slate-100"><span>{m} · {nome}</span><span className="text-slate-400">{meta.tipi[meta.piano.find((p) => p.codice.startsWith(m))?.tipo]}</span></div>
            {meta.piano.filter((p) => p.codice.startsWith(`${m}.`)).map((p) => (
              <div key={p.codice} className="flex items-center justify-between border-t border-slate-100 px-4 py-1.5 text-sm" data-testid={`coge-conto-${p.codice}`}>
                <span><span className="mr-2 font-mono text-xs text-slate-500">{p.codice}</span>{p.nome}</span>
                {admin && !p.standard && <Button variant="ghost" size="icon" className="h-7 w-7" data-testid={`coge-del-conto-${p.codice}`} onClick={() => del(p.codice)}><Trash2 className="h-3.5 w-3.5 text-rose-600" /></Button>}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
